import type { RebateTierTranslatedContent } from "../useRebateTierTranslatedContent";

import { Typo } from "../../Typo";
import { formatCycleEnd } from "./formatCycleEnd";
import { LabelledValue } from "./LabelledValue";

export type ProtectionCardProps = {
  freezePeriodValidTo: string | null;
  content: RebateTierTranslatedContent;
};

export const ProtectionCard = ({
  freezePeriodValidTo,
  content,
}: ProtectionCardProps) => (
  <div className="flex flex-col gap-6">
    {freezePeriodValidTo && (
      <LabelledValue
        label={content.protectionEnds}
        value={formatCycleEnd(freezePeriodValidTo)}
      />
    )}

    <div className="flex flex-col gap-4">
      <Typo element="p" type="bodySM" textColor="text-text-primary">
        {content.protectionBody}
      </Typo>
      <Typo element="p" type="bodySM" textColor="text-text-primary">
        {content.protectionAfter}
      </Typo>
    </div>
  </div>
);
